import React from "react";
import Logo from "../../Assets/logo.png";
import { ReactComponent as UserIcon } from "../../Assets/Icons/user.svg";
import { ReactComponent as CursorIcon } from "../../Assets/Icons/cursor-click.svg";
import { ReactComponent as DocumentIcon } from "../../Assets/Icons/document-text.svg";
import { ReactComponent as HomeIcon } from "../../Assets/Icons/home.svg";
import { ReactComponent as LightBulbIcon } from "../../Assets/Icons/light-bulb.svg";
import { ReactComponent as UserGroupIcon } from "../../Assets/Icons/user-group.svg";
import { ReactComponent as ClipboardIcon } from "../../Assets/Icons/clipboard-check.svg";
import { ReactComponent as AdjustmentsIcon } from "../../Assets/Icons/adjustments.svg";
import { ReactComponent as CogIcon } from "../../Assets/Icons/cog.svg";
import { ReactComponent as GlobeIcon } from "../../Assets/Icons/globe.svg";
import { Link } from "react-router-dom";

const sidebarLinks = [
  {
    icon: <HomeIcon />,
    name: "My AI Workspace",
    link: "/workspace",
  },
  {
    icon: <UserIcon />,
    name: "Individual Profile",
    link: "/individual-profile",
  },
  {
    icon: <UserGroupIcon />,
    name: "Team Profile",
    link: "/team-profile",
  },
  {
    icon: <DocumentIcon />,
    name: "AI Projects",
    link: "/all-projects",
  },
  {
    icon: <ClipboardIcon />,
    name: "Tasks",
    link: "/my-tasks",
  },
  {
    icon: <CursorIcon />,
    name: "AI Collab",
    link: "/",
  },
  {
    icon: <LightBulbIcon />,
    name: "Ask Generative AI",
    link: "/",
  },
  {
    icon: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-uqopch"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="PersonSearchIcon"
        fill="#9CA3AF"
        width={24}
        height={24}
      >
        <circle cx={10} cy={8} r={4} />
        <path d="M10.35 14.01C7.62 13.91 2 15.27 2 18v2h9.54c-2.47-2.76-1.23-5.89-1.19-5.99zm9.08 4.01c.36-.59.57-1.28.57-2.02 0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4c.74 0 1.43-.22 2.02-.57L20.59 22 22 20.59l-2.57-2.57zM16 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
      </svg>
    ),
    name: "Search People",
    link: "/search-people",
  },
  {
    icon: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-uqopch"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="ScreenSearchDesktopIcon"
        fill="#9CA3AF"
        width={24}
        height={24}
      >
        <path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4ZM4 16V6h16v10.01L4 16Zm5.0967-6.0469c0-1.027.836-1.864 1.864-1.864 1.027 0 1.864.837 1.864 1.864 0 1.027-.837 1.864-1.864 1.864-1.028 0-1.864-.837-1.864-1.864Zm7.032 4.236-2.482-2.482c.331-.505.527-1.107.527-1.754 0-1.772-1.441-3.213-3.213-3.213s-3.214 1.441-3.214 3.213 1.442 3.214 3.214 3.214c.636 0 1.225-.192 1.724-.511l2.489 2.488.955-.955Z" />
      </svg>
    ),
    name: "Search Teams",
    link: "/team-profile",
  },
];

const Sidebar = () => {
  return (
    <aside className="h-[100vh] w-[14%] border-r-2 py-2 flex flex-col items-start justify-between fixed top-0 bg-white">
      <div className="w-full">
        <img className="pl-4" src={Logo} alt="logo" loading="eager" />
        <ul className="px-2 w-full mt-6">
          {sidebarLinks.map((link) => {
            return (
              <Link to={link.link}>
                <li
                  className="flex flex-row items-center justify-start py-2 px-2 cursor-pointer rounded ease-in-out hover:bg-gray-100"
                  key={link.name}
                >
                  {link.icon}
                  <p className="ml-2 font-medium">{link.name}</p>
                </li>
              </Link>
            );
          })}
        </ul>
      </div>
      {/* <div className="flex flex-row items-center justify-center gap-x-4 self-center">
        <AdjustmentsIcon />
        <CogIcon />
        <GlobeIcon />
      </div> */}
    </aside>
  );
};

export default Sidebar;
